import Vue from "vue";
import Router from "vue-router";
import HomePage from "../pages/home/HomePage.vue";
import AboutPage from "../pages/about/AboutPage.vue";
import DevelopmentHistoryPage from "../pages/about/DevelopmentHistoryPage.vue";
import Product500Page from "../pages/products/Product500Page.vue";
import Product400Page from "../pages/products/Product400Page.vue";
import Product220Page from "../pages/products/Product220Page.vue";
import Product110Page from "../pages/products/Product110Page.vue";
import DryTypePage from "../pages/products/DryTypePage.vue";
import OilImmersedPage from "../pages/products/OilImmersedPage.vue";
import SpecialTransformerPage from "../pages/products/SpecialTransformerPage.vue";
import NewEnergyPage from "../pages/products/NewEnergyPage.vue";
import ExportProductPage from "../pages/products/ExportProductPage.vue";
import ProductItemDetailPage from "../pages/products/ProductItemDetailPage.vue";
import NewsPage from "../pages/news/NewsPage.vue";
import IndustryNewsPage from "../pages/news/IndustryNewsPage.vue";
import CompanyNewsPage from "../pages/news/CompanyNewsPage.vue";
import NewsDetailPage from "../pages/news/NewsDetailPage.vue";
import HonorsPage from "../pages/honors/HonorsPage.vue";
import GalleryPage from "../pages/gallery/GalleryPage.vue";
import CasesPage from "../pages/cases/CasesPage.vue";
import CaseDetailPage from "../pages/cases/CaseDetailPage.vue";
import ContactPage from "../pages/contact/ContactPage.vue";
import MarketingCenterPage from "../pages/contact/MarketingCenterPage.vue";
import CareersPage from "../pages/contact/CareersPage.vue";
import MessagePage from "../pages/contact/MessagePage.vue";

Vue.use(Router);

function scrollPageToTop() {
  if (typeof window === "undefined") {
    return;
  }

  window.scrollTo({ top: 0, left: 0, behavior: "auto" });

  if (document.documentElement) {
    document.documentElement.scrollTop = 0;
    document.documentElement.scrollLeft = 0;
  }

  if (document.body) {
    document.body.scrollTop = 0;
    document.body.scrollLeft = 0;
  }

  const app = document.getElementById("app");
  if (app) {
    app.scrollTop = 0;
    app.scrollLeft = 0;
  }
}

const router = new Router({
  mode: "hash",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    { path: "/", name: "home", component: HomePage },
    { path: "/about", name: "about", component: AboutPage },
    { path: "/about/company", redirect: "/about" },
    { path: "/about/history", name: "development-history", component: DevelopmentHistoryPage },
    { path: "/products", name: "products", redirect: "/products/oil-immersed" },
    { path: "/products/500kv", name: "products-500kv", component: Product500Page },
    { path: "/products/330-400kv", name: "products-330-400kv", component: Product400Page },
    { path: "/products/220kv", name: "products-220kv", component: Product220Page },
    { path: "/products/110kv", name: "products-110kv", component: Product110Page },
    { path: "/products/dry-type", name: "products-dry-type", component: DryTypePage },
    { path: "/products/oil-immersed", name: "products-oil-immersed", component: OilImmersedPage },
    { path: "/products/special", name: "products-special", component: SpecialTransformerPage },
    { path: "/products/new-energy", name: "products-new-energy", component: NewEnergyPage },
    { path: "/products/export", name: "products-export", component: ExportProductPage },
    { path: "/products/detail/:slug", name: "product-item-detail", component: ProductItemDetailPage },
    { path: "/news", name: "news", redirect: "/news/company" },
    { path: "/news/industry", name: "news-industry", component: IndustryNewsPage },
    { path: "/news/company", name: "news-company", component: CompanyNewsPage },
    { path: "/news/detail/:slug", name: "news-detail", component: NewsDetailPage, meta: { solidHeader: true } },
    { path: "/honors", name: "honors", component: HonorsPage },
    { path: "/honors/honor-certificates", redirect: "/honors" },
    { path: "/honors/certifications", redirect: "/honors" },
    { path: "/honors/reports", redirect: "/honors" },
    { path: "/honors/patents", redirect: "/honors" },
    { path: "/gallery", name: "gallery", component: GalleryPage },
    { path: "/cases", name: "cases", component: CasesPage },
    { path: "/cases/:slug", name: "case-detail", component: CaseDetailPage, meta: { solidHeader: true } },
    { path: "/contact", name: "contact", component: ContactPage },
    { path: "/contact/marketing", name: "contact-marketing", component: MarketingCenterPage },
    { path: "/contact/careers", name: "contact-careers", component: CareersPage },
    { path: "/contact/message", name: "contact-message", component: MessagePage }
  ]
});

if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

router.afterEach((to, from) => {
  if (to.fullPath === from.fullPath) {
    return;
  }

  Vue.nextTick(() => {
    scrollPageToTop();
    window.setTimeout(scrollPageToTop, 80);
  });
});

export default router;
